import { widgetDefaultsFromFields } from "../widgetDefaultsFromFields";

export const LATEST_BLOGS_1_CONSTANTS = {
  LATEST_BLOGS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Section title",
      value: "Latest Blogs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Section heading",
      required: false,
      defaultValue: "Latest Blogs",
    },
    {
      fieldName: "title_text_color",
      label: "Title color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "read_more_label",
      label: "Read more label",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Read More",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "read_more_text_color",
      label: "Read more color",
      value: "#943126",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#943126",
      required: false,
      defaultValue: "#943126",
    },
    {
      fieldName: "nav_button_active_bg",
      label: "Carousel active button",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#BE2330",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "nav_button_inactive_bg",
      label: "Carousel inactive button",
      value: "#FECACA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FECACA",
      required: false,
      defaultValue: "#FECACA",
    },
    {
      fieldName: "nav_icon_color",
      label: "Carousel icon color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_border_color",
      label: "Card border color",
      value: "#E0E0E0",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E0E0E0",
      required: false,
      defaultValue: "#E0E0E0",
    },
    {
      fieldName: "fetch_latest_blogs",
      label: "Fetch latest blogs",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Load up to 30 most recently updated published blog pages for this university",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],
};

export const LATEST_BLOGS_1_WIDGET_DEFAULTS = {
  ...widgetDefaultsFromFields(
    LATEST_BLOGS_1_CONSTANTS.LATEST_BLOGS_FIELDS_CONFIG,
  ),
  metadata: [],
};
